// @ts-nocheck
import React from "react";

export default function FormChoicesOption({unique, question, option, onChange, answers, isSelected}) {
	return (
		<div
			className="option-cont d-flex align-items-center"
			data-form-option-id={option?.optionId}
		>
			<label className="d-flex align-items-center w-100 cursor-pointer option-label">
				<div>
					<input
						type={unique ? "radio" : "checkbox"}
						className='option-value me-2'
						name={"question-option" + question?.questionId}
						// A choice answer stores the option text as its value
						// (same as the existing data), plus its optionId.
						onChange={(e) => onChange({
							...option,
							value: option?.value,
							state: e.target.checked,
							unique
						})}
						checked={isSelected(option.optionId)}
					/>
				</div>
				<div className="option-value">{option.value}</div>
			</label>
		</div>
	);
}
